import React from 'react';
import { useTranslation } from '@jupiter/plugin-runtime/i18n';
import { PreparePage } from '@/layouts';
import { RoleType } from '@/constants';
import {
  CollapsePanel,
  Error,
  ListWidget,
  SkeletonFramework,
} from '../components';
import { Menu } from './Menu';
import { Content } from './Content';
import { PolicyItem } from './PolicyItem';
import { ReactComponent as NewIcon } from './imgs/NewIcon.svg';
import { usePolicy } from './index.ViewHook';
import { REGION_CONFIG } from '@/region-config';
import { ContentsType } from '@/api/seller/serv/oec_seller_learning_center_api';

export const Policy = () => {
  const { t } = useTranslation();
  const { latestPolicy, policyCourses, wait, handleChange, handleItemClick } =
    usePolicy();

  return (
    <PreparePage
      wait={wait}
      loadingNode={
        <SkeletonFramework
          className="mt-24"
          block={1}
          item={12}
          showRight={true}
        />
      }
      errorNode={reload => <Error className="mt-24" onRetry={reload} />}>
      <CollapsePanel
        onChange={handleChange}
        tab={ContentsType.Policy_Center}
        forSeller={{
          menu: <Menu type={RoleType.Seller} />,
          content: (
            <Content
              type={RoleType.Seller}
              onItemClick={(item, index, pageNumber) => {
                handleItemClick(
                  item,
                  'seller_university_homepage_policy_content_list_for_seller',
                  index,
                  pageNumber,
                );
              }}
            />
          ),
        }}
        forCreator={{
          menu: <Menu type={RoleType.Creator} />,
          content: (
            <Content
              type={RoleType.Creator}
              onItemClick={(item, index, pageNumber) => {
                handleItemClick(
                  item,
                  'seller_university_homepage_policy_content_list_for_creator',
                  index,
                  pageNumber,
                );
              }}
            />
          ),
        }}
        rightNode={
          <div className="ml-24 w-[208px]">
            <div className="sticky top-[160px]">
              {!!latestPolicy?.length && (
                <ListWidget
                  header={t('academy_policy_latest_title')}
                  items={latestPolicy}
                  renderItem={(item, index) => (
                    <PolicyItem
                      key={item.learning_id}
                      avatar={<NewIcon className="mt-[5px]" />}
                      title={item.name}
                      datetime={item.modify_time}
                      onClick={() =>
                        handleItemClick(
                          item,
                          'seller_university_homepage_policy_content_latest_updates',
                          index,
                        )
                      }
                    />
                  )}
                />
              )}
              {!!policyCourses?.length && !REGION_CONFIG.notNeedCourse && (
                <ListWidget
                  className="mt-16"
                  header={t('academy_policy_couse_title')}
                  items={policyCourses}
                  renderItem={(item, index) => (
                    <PolicyItem
                      key={item.learning_id}
                      avatar={
                        <img
                          src={item.image}
                          className="w-[70px] h-[70px] mr-4 object-cover rounded-4"
                          alt={'policy item image'}
                        />
                      }
                      title={item.name}
                      datetime={item.modify_time}
                      onClick={() =>
                        handleItemClick(
                          item,
                          'seller_university_homepage_policy_content_policy_courses',
                          index,
                        )
                      }
                    />
                  )}
                />
              )}
            </div>
          </div>
        }
      />
    </PreparePage>
  );
};
